import React, { useEffect, useState } from "react";
import "./styles/Legal.css";
import Footer from "../components/Footer";
import Wrapper from "../components/Wrapper";
import { useLanguage } from "../LanguageContext";
import { axiosInstance } from "../helper/axiosInstance";

function PrivacyPolicy() {
    const { language, textContent } = useLanguage();
    const [data, setData] = useState({ content: "" });

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    useEffect(() => {
        const lang = language === "ARM" ? "hy" : language === "ENG" ? "en" : "ru";
        axiosInstance.get("/privacy-policy/lang?lang=" + lang).then((response) =>
            setData(response.data)
        );
    }, [language]);

    return (
        <Wrapper>
            <div className="legal">
                <div className="legal-header">
                    <span style={dynamicStyles}>{textContent[language].privacyPolicy}</span>
                    <div className="legal-header_icons">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.0164407 3.82196L0 12L3.99046 12L3.99046 3.99715C4.00629 3.99715 4.9794 4.00325 4.9794 4.0002L12 4.0002L12 -5.24537e-07L3.83761 -1.67747e-07C1.73064 -7.56487e-08 0.0219223 1.70984 0.0176598 3.82196"
                                fill="#243BE2"
                            />
                        </svg>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.17804 11.9836L0 12L0 8.00954L8.00285 8.00954C8.00285 7.99371 7.99675 7.0206 7.9998 7.0206L7.9998 0H12L12 8.16239C12 10.2694 10.2902 11.9781 8.17804 11.9823"
                                fill="#ADF233"
                            />
                        </svg>
                    </div>
                </div>
                <div className="legal-title">
                    <h1 style={dynamicStyles}>{textContent[language].privacyPolicy}</h1>
                </div>
                {data.content && (
                    <div className="legal-description">
                        <p style={{ ...dynamicStyles, whiteSpace: "pre-wrap" }}>{data.content}</p>
                    </div>
                )}
            </div>
            <Footer />
        </Wrapper>
    );
}

export default PrivacyPolicy;
